(function () {
  'use strict';

  function factory() {
    'ngInject';

    var header = angular.element('#hq-main-header');
    var footer = angular.element('#hq-main-footer');

    return toggle;

    function toggle(show) {
      if (show) {
        header.show();
        footer.show();
      } else {
        header.hide();
        footer.hide();
      }
    }
  }

  angular
    .module('hq.tools.lighting')
    .factory('hqTLightingHeaderToggle', factory);
}());
